import { useTheme } from '@mui/material/styles';
import { HighlightOff } from '@mui/icons-material';
import { formatToAmount } from '@qrios/frontend-library';

import locales from '../../../../../../../../constants/locales';
import DetailsList from '../../../../../../../common/details-list';
import DetailsFactory from '../../../../../../../common/details-list/detailsFactory';
import { formatDate, TABLE_DATE_TIME_FORMAT } from '../../../../../../../../constants/helpers/dates';

import creditTypesMapperToString from '../../../../../../../../constants/validation/creditTypesToString';
import { WalletCreditInfoResponse } from '../../../../../client-balance/add-funds-to-your-wallet/interfaces';

interface Props {
  credit: WalletCreditInfoResponse;
}

const RejectedCredit = ({ credit }: Props) => {
  const theme = useTheme();
  const { details } = credit.info;

  const detailsDependingOnTheDetailsMessage = () => {
    const { detailsMessage } = credit.info.details;
    if (detailsMessage) {
      return (
        <DetailsList
          items={[
            {
              label: locales.operation.label.transferNarration,
              value: details.transferTitle
            },
            { label: locales.operation.label.accountNumberIban, value: details.bankAccountNumber },
            {
              label: locales.operation.label.transferAmount,
              value: credit.info.creditAmount ? formatToAmount(credit.info.creditAmount.value) : '-'
            },
            {
              label: locales.operation.label.bankName,
              value: details.bankName
            },
            {
              label: locales.operation.label.type,
              value: creditTypesMapperToString(credit.info.details.type)
            },
            {
              label: locales.operation.label.rejectDate,
              value: details.rejectDate && formatDate(details.rejectDate, TABLE_DATE_TIME_FORMAT)
            },
            {
              label: locales.operation.label.detailsMessage,
              value: credit.info.details.detailsMessage
            }
          ]}
        />
      );
    }

    return (
      <DetailsList
        items={[
          {
            label: locales.operation.label.transferNarration,
            value: details.transferTitle
          },
          { label: locales.operation.label.accountNumberIban, value: details.bankAccountNumber },
          {
            label: locales.operation.label.transferAmount,
            value: credit.info.creditAmount ? formatToAmount(credit.info.creditAmount.value) : '-'
          },
          {
            label: locales.operation.label.bankName,
            value: details.bankName
          },
          {
            label: locales.operation.label.type,
            value: creditTypesMapperToString(credit.info.details.type)
          },
          {
            label: locales.operation.label.rejectDate,
            value: details.rejectDate && formatDate(details.rejectDate, TABLE_DATE_TIME_FORMAT)
          }
        ]}
      />
    );
  };
  return (
    <DetailsFactory
      header={{
        icon: { component: HighlightOff, color: theme.palette.error.main },
        id: credit.info.operationId,
        date: credit.info.attemptDate,
        status: credit.info.creditStatus
      }}
      operationContent={detailsDependingOnTheDetailsMessage()}
    />
  );
};

export default RejectedCredit;
